import React, { useState, useEffect, useRef } from "react";
import Design from "./components/Design";
import { Col, message, Row, Skeleton } from "antd";
import DesignsCategorys from "./category";
import ChooseImage from "./chooseImage";
import ControllerDesign from "./components/ControllerDesign";
import LayersDesign from "./layers/LayersDesign";
import { v4 as uuidv4 } from "uuid";
const DesignBanner = () => {
  const box_preview = useRef();
  const [loadigCanvas, setLoadingCanvas] = useState(true);
  const [widthCanvas, setWidthCanvas] = useState(600);
  const [ratio, setRatio] = useState(1);

  const [selectedBackground, setSelectedBackground] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectLayer, setSelectLayer] = useState(null);
  const [bgCurrentEditID, setBgCurrentEditID] = useState(null);

  const [backgroundDesign, setBackgroundDesign] = useState({});

  const [imgSetCurrent, setImgSetCurrent] = useState(null);
  const [bgSetCurrent, setBgSetCurrent] = useState(null);

  useEffect(() => {
    if (bgCurrentEditID && backgroundDesign.layers) {
      const newLayesC = [...backgroundDesign.layers];
      setSelectedBackground((prev) =>
        prev.map((e) => {
          if (e.id == bgCurrentEditID) {
            e.layers = newLayesC;
          }
          return e;
        })
      );
    }
  }, [backgroundDesign]);

  const handleApplyAll = () => {
    if (backgroundDesign.layers) {
      var newSelected = [...selectedBackground];
      const newLayesB = [...backgroundDesign.layers];
      newSelected = newSelected.map((e) => {
        e.layers = newLayesB;
        return e;
      });
      setSelectedBackground(newSelected);
    }
    message.success("Successfully applied!");
  };

  const changeBackground = (id, data) => {
    var layers = backgroundDesign.layers.filter(
      (e) => e.typeLayer == "image-default"
    );
    const findSelectedBackground = selectedBackground.find((e) => e.id == id);
    if (findSelectedBackground) {
      layers = findSelectedBackground.layers;
    }
    const background = {
      ...data,
      layers,
    };
    setBackgroundDesign((prev) => {
      return background;
    });
  };

  useEffect(() => {
    setLoadingCanvas(true);
    const widthCV = box_preview.current.offsetWidth;
    setWidthCanvas(widthCV);
    const newRatio = 1200 / widthCV;
    setRatio(newRatio);
    setBackgroundDesign((prev) => {
      return {
        id: uuidv4(),
        imageUrl:
          "https://d111oohu250q1p.cloudfront.net/c1370a70-7bd2-11ef-a3e4-4e5b5c96fb45__62wKGB9N7yWkCKo.png",
        layers: [
          {
            id: "fd13f79d-081a-4ba0-833c-fc03e9399f4d",
            typeLayer: "image-default",
            name: "Image",
            visible: true,
            width: 400,
            height: 400,
            url: "https://d111oohu250q1p.cloudfront.net/873f57f5-7c69-11ef-a3e4-4e5b5c96fb45__none-212.png",
            rotation: 0,
            x: (widthCV - 400) / 2,
            y: (widthCV - 400) / 2,
            shadowEnabled: true,
            shadowColor: "#000000",
            shadowOpacity: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 20,
            opacity: 1,
            stroke: "#000000",
            strokeWidth: 0,
            strokeEnabled: true,
          },
        ],
      };
    });
    setLoadingCanvas(false);
  }, []);

  useEffect(() => {
    if (
      selectedBackground.length >= 1 &&
      selectedBackground[0].imageUrl != bgSetCurrent
    ) {
      changeBackground(selectedBackground[0].id, selectedBackground[0]);
      setBgSetCurrent(selectedBackground[0].imageUrl);
      setTimeout(() => {
        setBgCurrentEditID(selectedBackground[0].id);
      }, 100);
    } else if (selectedBackground.length <= 1) {
      setBgCurrentEditID(null);
    }
  }, [selectedBackground]);

  useEffect(() => {
    if (selectedImage.length >= 1 && selectedImage[0].url != imgSetCurrent) {
      handleChangeDraggableImageUrl(selectedImage[0]);
      setImgSetCurrent(selectedImage[0].url);
      return;
    }
  }, [selectedImage]);

  const handleChangeDesign = (v) => {
    if (v.length <= 0) return;
    setBackgroundDesign((prev) => {
      const newDesign = {
        ...prev,
        layers: v,
      };
      return newDesign;
    });
  };

  const handleAddLayer = (v) => {
    setBackgroundDesign((prev) => {
      const newData = {
        ...prev,
        layers: [...prev.layers, v],
      };
      return newData;
    });
  };

  const handleSelectLayer = (layerId) => {
    setSelectLayer(layerId);
  };

  const handleChangeVisible = (layerID) => {
    setBackgroundDesign((prev) => {
      const newData = {
        ...prev,
        layers: prev.layers.map((e) => {
          if (e.id == layerID) {
            e.visible = !e.visible;
          }
          return e;
        }),
      };
      return newData;
    });
  };

  const handleRemoveLayer = (layerID) => {
    setBackgroundDesign((prev) => {
      const newData = {
        ...prev,
        layers: prev.layers.filter((e) => e.id != layerID),
      };
      return newData;
    });
  };

  const handleChangePosition = (newLayers) => {
    setBackgroundDesign((prev) => {
      const newData = {
        ...prev,
        layers: newLayers,
      };
      return newData;
    });
  };

  const handleChangeDraggableImageUrl = (v) => {
    const newBackgroundDesign = { ...backgroundDesign };
    newBackgroundDesign.layers = newBackgroundDesign.layers.map((i) => {
      if (i.typeLayer == "image-default") {
        const scaleNewImage = i.width / v.width;
        i.width = v.width * scaleNewImage;
        i.height = v.height * scaleNewImage;
        i.url = v.url;
      }
      return i;
    });
    setBackgroundDesign((prev) => {
      return { ...newBackgroundDesign };
    });
  };

  const handleChooseBgCurrentEdit = (id, data) => {
    changeBackground(id, data);
    setBgCurrentEditID(id);
  }

  return (
    <Row>
      <Col span={7}>
        <div className="box-control-edit-autobanner">
          <LayersDesign
            widthCanvas={widthCanvas}
            layerID={bgCurrentEditID}
            backgrounds={selectedBackground}
            onAddLayer={handleAddLayer}
            onRemoveLayer={handleRemoveLayer}
            onChangeVisible={handleChangeVisible}
            onChangePosition={handleChangePosition}
            onSelectLayer={handleSelectLayer}
            selectLayer={selectLayer}
            backgroundDesign={backgroundDesign}
          />
          <ChooseImage
            values={selectedImage}
            onChange={setSelectedImage}
            selectedBackground={selectedBackground}
            onChangeDraggableImageUrl={handleChangeDraggableImageUrl}
            backgroundDesign={backgroundDesign}
          />

          <div className={selectedImage.length <= 0 ? "disabled-box" : ""}>
            <DesignsCategorys
              selected={selectedBackground}
              onChange={setSelectedBackground}
              onChangeBackground={changeBackground}
              onChangeBgCurrentEditID={handleChooseBgCurrentEdit}
              selectedImage={selectedImage}
              layerID={bgCurrentEditID}
              backgroundDesign={backgroundDesign}
            />
          </div>
        </div>
      </Col>
      <Col
        span={10}
        style={{
          padding: "0px 10px",
          overflow: "auto",
        }}
      >
        <div ref={box_preview}>
          {loadigCanvas ? (
            <Skeleton active />
          ) : (
            <Design
              ratio={ratio}
              onApplyAll={handleApplyAll}
              widthCanvas={widthCanvas}
              onChange={handleChangeDesign}
              backgroundDesign={backgroundDesign}
              layerID={bgCurrentEditID}
              selectLayer={selectLayer}
              onSelectLayer={handleSelectLayer}
              backgrounds={selectedBackground}
              onChangeBackground={changeBackground}
              onChangeBgCurrentEditID={setBgCurrentEditID}
            />
          )}
        </div>
      </Col>
      <Col
        span={7}
        style={{
          padding: "0px 10px",
        }}
      >
        <ControllerDesign
          selectedBackground={selectedBackground}
          selectedImage={selectedImage}
          ratio={ratio}
        />
      </Col>
    </Row>
  );
};

export default DesignBanner;
